const React = require("react")
const Overlay = require("./src/components/overlay").default
exports.wrapPageElement = ({ element, props }) => <Overlay {...props}>{element}</Overlay>
